import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { AppCommonModule } from '@commons/commons.module';

// Consts
import { ROUTE } from '@consts/routes';

// Resolvers
import { ProgramsResolve } from '@core/resolvers/programs/programs.resolve';

// Components
import { HomeComponent } from './home.component';

const routes: Route[] = [
  {
    path: ROUTE.EMPTY,
    component: HomeComponent,
  },
  {
    path: ':program',
    component: HomeComponent,
    resolve: { current_program: ProgramsResolve },
  },
];

@NgModule({
  declarations: [
    HomeComponent,
  ],
  imports: [
    CommonModule,
    AppCommonModule,
    RouterModule.forChild(routes),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HomeModule {}
